import { useState } from 'react';
import { Field, FieldLabel } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { useTranslation } from 'react-i18next';

const FORM_ID = 'form-tokens-history-export';

const EXPORT_MODES = {
    ALL: 'all',
    DATE_RANGE: 'date_range',
    SEARCH: 'search',
};

export { FORM_ID };

export default function FormTokensHistoryExport({ onSubmit, isSubmitting }) {
    const { t } = useTranslation();
    const [mode, setMode] = useState(EXPORT_MODES.ALL);
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [search, setSearch] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        const params = { export: true };

        if (mode === EXPORT_MODES.DATE_RANGE) {
            if (dateFrom) params.date_from = dateFrom;
            if (dateTo) params.date_to = dateTo;
        } else if (mode === EXPORT_MODES.SEARCH) {
            if (search.trim()) params.search = search.trim();
        }

        onSubmit(params);
    };

    return (
        <form id={FORM_ID} onSubmit={handleSubmit} className="space-y-5">
            <RadioGroup value={mode} onValueChange={setMode} className="space-y-3">
                <Field orientation="horizontal" className="items-center">
                    <RadioGroupItem value={EXPORT_MODES.ALL} id="export-all" />
                    <Label htmlFor="export-all" className="cursor-pointer">
                        {t('tokens:historiqueComplet')}
                    </Label>
                </Field>

                <Field orientation="horizontal" className="items-center">
                    <RadioGroupItem value={EXPORT_MODES.DATE_RANGE} id="export-date-range" />
                    <Label htmlFor="export-date-range" className="cursor-pointer">
                        {t('tokens:parPeriode')}
                    </Label>
                </Field>

                <Field orientation="horizontal" className="items-center">
                    <RadioGroupItem value={EXPORT_MODES.SEARCH} id="export-search" />
                    <Label htmlFor="export-search" className="cursor-pointer">
                        {t('tokens:parRecherche')}
                    </Label>
                </Field>
            </RadioGroup>

            {mode === EXPORT_MODES.DATE_RANGE && (
                <div className="space-y-3 pl-6">
                    <Field>
                        <FieldLabel htmlFor="export-date-from">{t('tokens:dateDeDebut')}</FieldLabel>
                        <Input
                            id="export-date-from"
                            type="date"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                            max={dateTo || undefined}
                            disabled={isSubmitting}
                        />
                    </Field>
                    <Field>
                        <FieldLabel htmlFor="export-date-to">{t('tokens:dateDeFin')}</FieldLabel>
                        <Input
                            id="export-date-to"
                            type="date"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                            min={dateFrom || undefined}
                            disabled={isSubmitting}
                        />
                    </Field>
                </div>
            )}

            {mode === EXPORT_MODES.SEARCH && (
                <div className="pl-6">
                    <Field>
                        <FieldLabel htmlFor="export-search-input">{t('tokens:termeDeRecherche')}</FieldLabel>
                        <Input
                            id="export-search-input"
                            type="text"
                            placeholder={t('tokens:exAchatNomDUtilisateur')}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            disabled={isSubmitting}
                        />
                    </Field>
                </div>
            )}
        </form>
    );
}
